import {
  ADD_CHANNELS,
  UPLOAD_MENU,
  SETUP_MIDDLEWARE,
  APPROVE_BSP,
  VERIFY_WHATSAPP_NUMBER,
  VERIFY_FACEBOOK_ACCOUNT,
  AUTHORISE_ACCOUNT,
  CREATE_FACEBOOK_CATALOGUE,
  REVIEW_WHATSAPP_MENU,
  DELIVERY_RADIUS_AND_CHARGES,
  COMPLETED
} from "./IntegrationStatus";

export const ADD_CHANNELS_STEP = [
  {
    id: ADD_CHANNELS,
    title: "Add Channels",
    component: "",
    props: {}
  }
];
export const MENU_STEPS = [
  {
    id: UPLOAD_MENU,
    title: "Upload Menu",
    component: "integration-stepper-upload-menu",
    props: {
      info: "Upload your restaurant menu to Foaps by clicking the 'Upload Menu' button below or by navigating to the MenuBook page located on the top right of your screen.",
      buttonText: " Upload Menu",
      targetUrl: "/menu"
    }
  }
];
export const MIDDLEWARE_STEPS = [
  {
    id: SETUP_MIDDLEWARE,
    title: "Setup Middleware ",
    component: "integration-stepper-setup-middleware",
    props: {}
  }
];
export const MIDDLEWARE_STEPS_MINIFIED = [];
export const WHATSAPP_STEPS = [
  {
    id: APPROVE_BSP,
    title: "Approve BSP",
    component: "integration-stepper-approve-bsp",
    props: {
      info: "Please go to your business manager account and approve Airtel as your BSP for WhatsApp ordering facility.",
      buttonText: "Visit Facebook Business Manager Account",
      targetUrl: "https://business.facebook.com"
    }
  },
  {
    id: VERIFY_WHATSAPP_NUMBER,
    title: "Verify your mobile number for WhatsApp integartion",
    component: "integration-stepper-verify-mobile-for-whatsapp-integration",
    props: {}
  },
  {
    id: VERIFY_FACEBOOK_ACCOUNT,
    title: "Verify your account on Facebook business manager",
    component: "integration-stepper-approve-bsp",
    props: {
      info: "Please go to your business manager account and approve Airtel as your BSP for WhatsApp ordering facility.",
      buttonText: "Visit Facebook Business Manager Account",
      targetUrl: "https://business.facebook.com"
    }
  },
  {
    id: CREATE_FACEBOOK_CATALOGUE,
    title: "Create  a catalogue in the Facebook commerce manager ",
    component: "integration-stepper-create-facebook-catalogue",
    props: {
      targetUrl: "https://business.facebook.com/products/catalogs/new"
    }
  },
  {
    id: AUTHORISE_ACCOUNT,
    title: "Authorise your account",
    component: "integration-stepper-approve-bsp",
    props: {
      info: "Please go to your business manager account and approve Airtel as your BSP for WhatsApp ordering facility.",
      buttonText: "Continue with Facebook",
      id: AUTHORISE_ACCOUNT
    }
  },

  // {
  //   id: REVIEW_WHATSAPP_MENU,
  //   title: "Review menu",
  //   component: "integration-stepper-review-whatsapp-menu",
  //   props: {}
  // },
  {
    id: DELIVERY_RADIUS_AND_CHARGES,
    title: "Delivery radius and charges",
    component: "integration-stepper-delivery-radius-and-charges",
    props: {}
  }
];
export const WHATSAPP_STEPS_MINIFIED = [
  {
    id: CREATE_FACEBOOK_CATALOGUE,
    title: "Create  a catalogue in the Facebook commerce manager ",
    component: "integration-stepper-create-facebook-catalogue",
    props: {
      targetUrl: "https://business.facebook.com/products/catalogs/new"
    }
  },
  {
    id: AUTHORISE_ACCOUNT,
    title: "Authorise your account",
    component: "integration-stepper-approve-bsp",
    props: {
      info: "Please go to your business manager account and approve Airtel as your BSP for WhatsApp ordering facility.",
      buttonText: "Continue with Facebook",
      id: AUTHORISE_ACCOUNT
    }
  }
];
